// ============================================================
// MAXCONST — Projects API Layer
// Tất cả gọi API liên quan đến projects ở đây
// ============================================================

import type { ProjectResponse, ProjectCategory } from './types'

export const getApiBase = (): string => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return 'http://localhost:3001'
  }
  // URL backend trên Render (tên dịch vụ: maxconst-backend)
  return 'https://maxconst-backend.onrender.com'
}

/**
 * Fetch projects từ backend API (Express scraping server)
 * @param category - Loại dự án
 * @param pages - Số trang scrape (mặc định 10)
 */
export const fetchProjectsByCategory = async (
  category: ProjectCategory,
  pages: number = 10
): Promise<ProjectResponse> => {
  try {
    const url = `${getApiBase()}/api/projects/${category}?pages=${pages}`

    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal: AbortSignal.timeout(30_000), // 30s timeout
    })

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`)
    }

    const data: ProjectResponse = await response.json()
    return data
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Không thể kết nối đến API'
    return {
      success: false,
      data: [],
      message,
    }
  }
}
